import swal from 'sweetalert';
import Swal from 'sweetalert2'; 
//export const  API_URL="http://localhost:8080" 
export const  API_URL="http://13.233.36.253:8080/partner_app_admin_api"
//export const  API_URL="http://192.168.0.29:8080/partner_app_api"//"
//export const  API_URL="https://partnerapi.weikfield.com"
//export const  API_URL="http://127.0.0.1:8080"

  
export function  SendPasswordByMail(login_id) {
    console.clear();
  if(isEmpty(login_id))
  {
      ShowSwallError("Please Enter User Id")
      return false;
  }
 
  const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ 
          "login_id":login_id,
          
      })
  };

  SwalBlokUI("Please wait..");
  let logourl = API_URL + "/ForgotPassword/SendForgotPasswordMail";
  fetch(logourl, requestOptions)
      .then(res => res.json())   
      .then(json => {
          SwalUnBlokUI();
          if(json.hasOwnProperty("error"))
          {
              Swal.fire(
                  'Error',
                  json.status+"  "+json.error+"</br>"+json.message,
                  'warning'
                )
                console.clear();
          }
          else
          { 
          
          if(json.data.error_code==="0"){
              Swal.fire({
                  title: "Done!",
                  html: json.data.msg   ,
                  icon: "success",
              });
              console.clear();
          }
          else {
              Swal.fire({
                  title: "OOPS!", 
                  html: json.data.msg   ,
                  icon: "warning",
              });
              console.clear();
          }
       }
      })
      .catch( (e) => {
          SwalUnBlokUI();
          Swal.fire({
              title: "OOPS!..",
              html: e,                  
              icon: "warning",
          });
          console.log(e)
      })
} 

export function  SwalBlokUI(msg) {
    const content = document.createElement('div');
    const input = document.createElement('img');
    input.src = 'https://miro.medium.com/max/875/1*CsJ05WEGfunYMLGfsT2sXA.gif';
    input.width="250"
    content.appendChild(input);
    
                        swal({
                           
                            text:msg,
                              allowOutsideClick: false,
                              closeOnClickOutside: false,

                            buttons:false,
                            content
                        });
   
} 
export function  SwalUnBlokUI(msg) {

  swal.close();
} 
export function  ShowSwallError(msg) {
 
Swal.fire({
  title: "Error",
  html: msg,
  icon: "warning"
}
)
} 

export function  isEmpty(obj) {

    // null and undefined are "empty"
    if (obj == null) return true;
    if (obj == "null") return true;

    // Assume if it has a length property with a non-zero value
    // that that property is correct.
    if (obj.length > 0)    return false;
    if (obj.length === 0)  return true;

    // If it isn't an object at this point
    // it is empty, but it can't be anything *but* empty
    // Is it empty?  Depends on your application.
    if (typeof obj !== "object") return true;

    // Otherwise, does it have any properties of its own?
    // Note that this doesn't handle
    // toString and valueOf enumeration bugs in IE < 9
    for (var key in obj) {
        if (hasOwnProperty.call(obj, key)) return false;
    }

    return true;
} 